import { StateApiError } from '@/store/modules/error';
import { ErrorCode } from '@/resources/error/ErrorCode';

export type ApiErrorClass = {
  status: number;
  isModal?: boolean;
} & Partial<StateApiError>;

export const apiErrorList: ApiErrorClass[] = [
  {
    // セッションタイムアウト
    status: 401,
    code: ErrorCode.InvalidJWTToken,
    type: 'redirect',
    i18nText: 'error.InvalidJWTToken'
  },
  {
    // 規定回数内の生年月日認証失敗
    status: 403,
    code: ErrorCode.FailedBirthAuth,
    type: 'warn',
    i18nText: 'error.FailedBirthAuth'
  },
  {
    // 規定回数以上の生年月日認証失敗
    status: 403,
    code: ErrorCode.ExpiresAtBirthAuth,
    type: 'redirect',
    i18nText: 'error.ExpiresAtBirthAuth'
  },
  {
    // 撮影結果の自動判定でNG 免許証の表・裏、顔正面
    status: 400,
    code: ErrorCode.CVInvalidFeature,
    isModal: false
  },
  {
    // 撮影結果の自動判定でNG 免許証の斜めの免許証の表と斜めの同一性確認
    status: 400,
    code: ErrorCode.CVDifferentDriverLicense,
    isModal: false
  },
  {
    // 申請に必要な情報が足りない
    status: 409,
    type: 'redirect',
    code: ErrorCode.UnconfirmedDataset,
    i18nText: 'error.UnconfirmedDataset'
  },
  {
    // 申請有効期限切れステータスエラー
    status: 403,
    type: 'redirect',
    code: ErrorCode.KYCRequestExpiredStatus,
    i18nText: 'error.KYCRequestExpiredStatus'
  },
  {
    // 申請中ではない不正なステータスエラー
    status: 403,
    type: 'redirect',
    code: ErrorCode.KYCRequestInvalidStatus,
    i18nText: 'error.KYCRequestInvalidStatus'
  },
  {
    // 確認画像のタイムアウトエラー
    status: 403,
    type: 'redirect',
    code: ErrorCode.KYCRequestImageTimeout,
    i18nText: 'error.DefaultErrorMessage'
  },
  {
    // 不正な多言語情報が取得された
    status: 400,
    type: 'redirect',
    code: ErrorCode.UnexpectedLocaleInfomation,
    i18nText: 'error.DefaultErrorMessage'
  },
  {
    // 利用できない補助書類コード
    status: 403,
    code: ErrorCode.ErrorCode2022,
    type: 'warn'
  },
  {
    // 指定できない補助書類の撮影枚数
    status: 403,
    code: ErrorCode.ErrorCode2023,
    type: 'warn'
  }
];
